import Registerbutton from "../../../component/Registerbutton";

export default function Rules() {
  return (
    <div className="flex items-center justify-center flex-col pt-10">
      <div className="w-[500px] max-[600px]:w-[300px] flex items-center justify-center bg-[#2B2B2B] rounded-xl text-white text-center flex-col mb-10">
        <span className="font-black text-xl pt-5">قوانین و مقررات دوره</span>
        <div className="w-10/12 h-px bg-gradient-to-r from-transparent via-white to-transparent my-5 max-[600px]:my-2" />
        <span className="font-black text-md p-7 max-[600px]:text-sm  ">
          با زدن دکمه ثبت نام شما قوانین زیر رو می پذیرید
        </span>

        <div className="w-10/12 text-right flex flex-col items-end justify-start">
          <div className="flex py-2">
            <div>
              <span className="max-[600px]:text-sm">
                ما در این دوره فقط و فقط آموزش ساخت توکن رو ارائه میدیم
              </span>
            </div>
            <div className="w-[22px] h-[22px] bg-[#7E42FF] rounded-md ml-2 max-[600px]:h-[15px]"></div>
          </div>

          <div className="flex py-2">
            <div>
              <span className="max-[600px]:text-sm">
                مسئولیت هرگونه استفاده از آموزشها ساخت توکن مارکتینگ و فعالیتهای
                بعدی کاملاً به عهده شخص شماست
              </span>
            </div>
            <div className="w-[40px] h-[22px] bg-[rgb(126,66,255)] rounded-md ml-2 max-[600px]:h-[15px]"></div>
          </div>

          <div className="flex py-2">
            <div>
              <span className="max-[600px]:text-sm">
                رسالت ما، ارتقاء سطح علمی در حوزه ی کریپتو و وب ۳ داخل کشوره نه
                ساخت پروژه های مشکوک یا اسکم
              </span>
            </div>
            <div className="w-[40px] h-[22px] bg-[#7E42FF] rounded-md ml-2 max-[600px]:h-[15px]"></div>
          </div>

          <div className="flex py-2">
            <div>
              <span className="max-[600px]:text-sm">
                من سالهاست به عنوان شکارچی میم کوینهای ترند فعالیت میکنم و هدفم
                اینه که به شما کمک کنم یه شکارچی حرفه ای بشین
              </span>
            </div>
            <div className="w-[45px] h-[22px] bg-[#7E42FF] rounded-md ml-2 max-[600px]:h-[15px]"></div>
          </div>

          <div className="flex py-2">
            <div>
              <span className="max-[600px]:text-sm">
                این دوره کمک میکنه ماهیت واقعی ساخت توکن مدیریت پروژه و تحلیل
                بازارو بشناسید ولی مسئولیت نهایی کارهاتون با خودتونه
              </span>
            </div>
            <div className="w-[45px] h-[22px] max-[600px]:h-[15px] bg-[#7E42FF] rounded-md ml-2"></div>
          </div>
        </div>

        <span className="font-black text-md py-5 w-10/12 max-[600px]:text-sm ">
          پس لطفا با آگاهی کامل ثبت نام کنین و بدونین که بعد از آموزش تصمیم و
          اقدام نهایی به عهده ی خودتونه
        </span>
      </div>
      <Registerbutton />
    </div>
  );
}
